<template>
  <Modal :open="open" @close="$emit('close')">
    <h1 class="text-center font-extrabold text-xl">Modifier la réclamation {{ complaint.friendlyId }}</h1>

    <Selector
      class="mt-3"
      id="status"
      name="status"
      label="Statut"
      :required="true"
      v-model="status"
      :options="statusOptions"
    />

    <Selector
      class="mt-3"
      id="theme"
      name="theme"
      label="Thème"
      :required="true"
      v-model="theme"
      :options="themeOptions"
    />

    <Selector
      class="mt-3"
      id="subtheme"
      name="subtheme"
      label="Sous-thème"
      :required="true"
      v-model="subtheme"
      :options="subthemeOptions"
    />

    <Selector
      class="mt-3"
      id="channel"
      name="channel"
      label="Canal"
      :required="true"
      v-model="channel"
      :options="channelOptions"
    />

    <FormField class="mt-3" id="subject" label="Sujet" name="subject" required v-model="subject" />

    <FormField class="mt-3" id="details" label="Détails" name="details" required v-model="details" />

    <FormField
      class="mt-3"
      id="reception_date"
      label="Date de réception"
      name="reception_date"
      type="date"
      required
      v-model="receptionDate"
    />

    <FormField
      class="mt-3"
      id="acknowledgement_sent_date"
      label="Date d'envoi de l'AR"
      name="acknowledgement_sent_date"
      type="date"
      v-model="acknowledgementSentDate"
    />

    <FormField
      class="mt-3"
      id="requested_amount"
      label="Montant demandé"
      name="requested_amount"
      trailing-add-ons="€"
      type="number"
      v-model="requestedAmount"
    />

    <FormField
      class="mt-3"
      id="reimbursed_amount"
      label="Montant remboursé"
      name="reimbursed_amount"
      trailing-add-ons="€"
      type="number"
      v-model="reimbursedAmount"
    />

    <div class="mt-3 flex justify-center">
      <GenericButton class="items-center" @click="updateResource">Mettre à jour</GenericButton>
    </div>
  </Modal>
</template>

<script>
import { FormField, GenericButton, Modal, Selector, convertDateFormat } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { GenericButton, FormField, Selector, Modal },
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    complaint: {
      required: true,
      type: Object,
    },
  },

  data: () => {
    return {
      status: null,
      theme: null,
      subtheme: null,
      channel: null,
      subject: null,
      details: null,
      requestedAmount: null,
      receptionDate: null,
      reimbursedAmount: null,
      acknowledgementSentDate: null,
    };
  },

  mounted() {
    this.initiateData();
  },

  emits: ["close", "updated"],

  watch: {
    open(newValue) {
      if (newValue) {
        this.initiateData();
      }
    },
  },

  computed: {
    ...mapGetters("complaints", ["statuses", "themes", "subthemes", "channels"]),

    statusOptions() {
      return this.statuses().map((status) => ({
        value: status,
        label: this.$t(`complaints.status.${status}`),
      }));
    },

    themeOptions() {
      return this.themes().map((theme) => ({
        value: theme,
        label: this.$t(`complaints.theme.${theme}`),
      }));
    },

    subthemeOptions() {
      return this.subthemes().map((subtheme) => ({
        value: subtheme,
        label: this.$t(`complaints.subtheme.${subtheme}`),
      }));
    },

    channelOptions() {
      return this.channels().map((channel) => ({
        value: channel,
        label: this.$t(`complaints.channel.${channel}`),
      }));
    },
  },

  methods: {
    ...mapActions("complaints", ["update"]),
    ...mapActions("notifications", ["notify"]),

    initiateData() {
      this.status = this.complaint?.status;
      this.theme = this.complaint?.theme;
      this.subtheme = this.complaint?.subtheme;
      this.channel = this.complaint?.channel;
      this.subject = this.complaint?.subject;
      this.details = this.complaint?.details;
      this.requestedAmount = this.complaint?.requestedAmount;
      this.receptionDate = this.complaint?.receptionDate ? convertDateFormat(this.complaint.receptionDate) : null;
      this.reimbursedAmount = this.complaint?.reimbursedAmount;
      this.acknowledgementSentDate = this.complaint?.acknowledgementSentDate
        ? convertDateFormat(this.complaint.acknowledgementSentDate)
        : null;
    },

    async updateResource() {
      const response = await this.update({
        id: this.complaint.id,
        data: {
          status: this.status,
          theme: this.theme,
          subtheme: this.subtheme,
          channel: this.channel,
          subject: this.subject,
          details: this.details,
          requestedAmount: this.requestedAmount,
          receptionDate: this.receptionDate,
          reimbursedAmount: this.reimbursedAmount,
          acknowledgementSentDate: this.acknowledgementSentDate,
        },
      });

      if (response?.success) {
        this.$emit("close");
        this.$emit("updated");
      }
    },
  },
};
</script>
